/** Maps legacy / duplicate category names onto the canonical id. */
export const CATEGORY_ALIASES = {
  "Restaurants i bars": "Restaurants",
};

export function canonicalCategoryId(categoryId) {
  const id = String(categoryId || "").trim();
  if (!id) return id;
  return CATEGORY_ALIASES[id] || id;
}

/**
 * Merge duplicate category names in shared app state.
 * Returns { data, changed } so callers can persist when needed.
 */
export function mergeDuplicateCategories(data = {}) {
  const settings = { ...(data.settings || {}) };
  const expenses = Array.isArray(data.expenses) ? data.expenses.map((item) => ({ ...item })) : [];
  const recurring = Array.isArray(data.recurring) ? data.recurring.map((item) => ({ ...item })) : [];
  const settlements = Array.isArray(data.settlements) ? data.settlements : [];

  let changed = false;

  for (const expense of expenses) {
    const next = canonicalCategoryId(expense.category);
    if (next && next !== expense.category) {
      expense.category = next;
      changed = true;
    }
  }

  for (const item of recurring) {
    const next = canonicalCategoryId(item.category);
    if (next && next !== item.category) {
      item.category = next;
      changed = true;
    }
  }

  const categories = Array.isArray(settings.categories) ? settings.categories : [];
  const byId = new Map();

  for (const raw of categories) {
    const category =
      typeof raw === "object" && raw?.id
        ? { ...raw, id: canonicalCategoryId(raw.id) }
        : { id: canonicalCategoryId(raw), icon: "📦", color: "#6f6458" };

    if (!category.id) continue;

    if (typeof raw === "object" && raw?.id && raw.id !== category.id) changed = true;

    const existing = byId.get(category.id);
    if (!existing) {
      byId.set(category.id, category);
      continue;
    }

    changed = true;
    byId.set(category.id, {
      ...existing,
      ...category,
      // Prefer a real icon over the generic box fallback.
      icon: betterIcon(existing.icon, category.icon),
      color: existing.color || category.color,
    });
  }

  const mergedCategories = [...byId.values()].sort((a, b) => a.id.localeCompare(b.id, "ca"));
  if (JSON.stringify(mergedCategories) !== JSON.stringify(categories)) changed = true;

  settings.categories = mergedCategories;

  return {
    changed,
    data: {
      settings,
      expenses,
      recurring,
      settlements,
    },
  };
}

function betterIcon(a, b) {
  const fallback = "📦";
  if (a && a !== fallback) return a;
  if (b && b !== fallback) return b;
  return a || b || fallback;
}
